import React from "react";
import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";
import SectionHeader from "@/components/home/SectionHeader";
import { EventCard } from "@/components/events/EventCard";

/**
 * Homepage Events row — legacy parity: live events sit right under the
 * hero, above everything else. Uses the shared legacy EventCard.
 * Hidden while the shared backend has no approved events.
 */
function useEvents() {
  return useQuery({
    queryKey: ["events", "NZ", "upcoming"],
    queryFn: async () => {
      const { data } = await sharedApi.get("/classifieds/events", {
        params: { country: "NZ", upcoming: true, limit: 8 },
      });
      return data.events || [];
    },
    staleTime: 2 * 60_000,
  });
}

export default function EventsRow() {
  const q = useEvents();
  const events = q.data || [];
  if (!q.isLoading && events.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 py-8">
      <SectionHeader title="Events" seeAllHref="/events" testId="section-events" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {q.isLoading &&
          Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="skeleton aspect-[4/3] rounded-xl" />
          ))}
        {events.slice(0, 4).map((e) => (
          <EventCard key={e.id} event={e} />
        ))}
      </div>
    </section>
  );
}
